import {Injectable, OnInit} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {interval, Observable, Subscription} from "rxjs";

import {Analyser} from "./analyserStatus";
import {tap} from "rxjs/operators";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class AnalyserStatusDataservice  {
  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  PutKey(key: number):  Observable<Analyser> {
    this.uiUrl = this.url.GetAnalyserUrl() + key;
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<Analyser>(this.uiUrl);
  }


}


